<template lang="pug">
  v-dialog(:value="value" @input="close" max-width="600")
    v-card(v-if="value")
      validation-observer(ref="obs" v-slot="{ invalid, handleSubmit }")
        v-card-title Добавить видео
          v-spacer
          v-btn(@click="close" icon)
            v-icon mdi-close
        v-card-text
          validation-provider(
            rules="required"
            name="Название"
            vid="name"
            v-slot="{ errors, valid }"
          )
            v-textarea(
              v-model="video.name"
              :error-messages="errors"
              label="Название видео"
              auto-grow
              rows="2"
              row-height="20"
              rounded filled
            )

          validation-provider(
            :rules="{ regex, required: true }"
            name="Ссылка на видео"
            vid="link"
            v-slot="{ errors, valid }"
          )
            v-text-field(
              v-model="video.link"
              :error-messages="errors"
              label="Ссылка на видео"
              rounded filled
            )

          validation-provider(
            rules=""
            name="Описание"
            vid="description"
            v-slot="{ errors, valid }"
          )
            v-textarea(
              v-model="video.description"
              :error-messages="errors"
              label="Описание"
              rounded filled
            )

        v-card-actions
          v-spacer
          v-btn(
            v-if="editData"
            color="success"
            :loading="buttonLoading"
            @click="handleSubmit(updateVideo)"
            text
          ) Изменить
          v-btn(
            v-else
            color="success"
            :loading="buttonLoading"
            @click="handleSubmit(addVideo)"
            text
          ) Добавить
          v-btn(color="warning" @click="close" text) Закрыть
</template>

<script>
import { YOUTUBE_LINK_REGEX } from '@/utils/youtube-utils';

export default {
  name: 'AddVideoDialog',
  props: {
    value: { type: Boolean, default: false },
    lessonInstance: { type: Object, default: null },
    editData: { type: Object, default: null },
  },
  data() {
    return {
      regex: YOUTUBE_LINK_REGEX,
      video: {
        name: '',
        link: '',
        description: '',
      },
      buttonLoading: false,
    };
  },
  watch: {
    value(val) {
      if (val && this.editData) {
        this.video = { ...this.editData };
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false);
      this.video = {};
      this.$refs.obs.reset();
    },
    addVideo() {
      if (this.lessonInstance) {
        this.buttonLoading = true;
        this.$rHandler(
          this.$api.lessons.createVideo(this.lessonInstance.id, this.video),
          (r) => {
            this.video = r.data.data;
            this.buttonLoading = false;
            this.$emit('video:add', { ...this.video });
            this.close();
          },
          () => {
            this.buttonLoading = false;
          },
        );
      } else {
        this.$emit('video:add', { ...this.video });
        this.close();
      }
    },
    updateVideo() {
      if (this.lessonInstance) {
        this.buttonLoading = true;
        this.$rHandler(
          this.$api.lessons.updateVideo(this.video.id, this.video),
          () => {
            this.buttonLoading = false;
            this.$emit('video:edit', { ...this.video });
            this.close();
          },
          () => {
            this.buttonLoading = false;
          },
        );
      } else {
        this.$emit('video:edit', { ...this.video });
        this.close();
      }
    },
  },
};
</script>

<style scoped>

</style>
